import Vue from "vue";
import VueRouter from "vue-router";
import { constantRouterMap } from "./router.config";
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: constantRouterMap,
});

// // 在路由切换前添加平滑滚动到顶部的全局钩子
// router.beforeEach((to, from, next) => {
//   // 使用window.scrollTo实现平滑滚动
//   window.scrollTo({ top: 0, behavior: "smooth" });
//   next();
// });

export default router;
